import { Button, Input, message } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { userForGetPassword } from '../../api/Verfiy';
import { countdown } from '../../utils/index';
const PageContainer = styled.div`
  width: 100%;
  height: calc(100vh - 181px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const PageTitle = styled.h2`
  font-size: 32px;
`;

const PageTip = styled.p`
  margin-bottom: 50px;
`;

const ForGetPassword = () => {
  // 定义变量
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(60);
  const [isFirst, setIsFirst] = useState(true);

  // 处理Email输入框的值
  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  // 处理点击发送验证码按钮
  const sendEmail = async () => {
    try {
      const { code } = await userForGetPassword({ email });
      if (code === '10000') {
        btncountdown();
      }
    } catch (error) {
      // console.log(error);
    }
  };

  // 处理点击发送验证码按钮
  const resendEmail = async () => {
    try {
      const { code } = await userForGetPassword({ email });
      if (code === '10000') {
        btncountdown();
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const handleSendEmail = async () => {
    if (isFirst) {
      sendEmail();
    } else {
      resendEmail();
    }
  };

  const btncountdown = () => {
    message.success('Mail sent successfully');
    setLoading(true);
    countdown(
      timer,
      (time) => {
        setTimer(time);
      },
      () => {
        setTimer(60);
        setLoading(false);
        setIsFirst(false);
      }
    );
  };

  return (
    <PageContainer>
      <PageContent>
        <PageTitle>Forgot password</PageTitle>
        <PageTip>Enter your email address for reset instructions</PageTip>
        <Input
          placeholder="Enter your email address"
          type="email"
          onChange={handleInputChange}
          style={{
            marginBottom: '30px',
          }}
          className={'custom-antd-input forget-password-input'}
        />
        <Button
          type="text"
          loading={loading}
          onClick={handleSendEmail}
          disabled={loading}
          style={{
            height: '42px',
            backgroundColor: '#18EAC4',
            borderColor: '#18EAC4',
            color: '#000',
            borderRadius: '6px',
          }}
        >
          {loading
            ? `  ` + timer + `s`
            : isFirst
            ? `Send reset link`
            : `Resend reset link`}
        </Button>
      </PageContent>
    </PageContainer>
  );
};

export default ForGetPassword;
